var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBigPdfExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.45,21.62L66.45,.62l-1.45-.62H15l-2,2V98l2,2H85l2-2V23l-.55-1.38Zm-6.11-.62h-13.33V7l13.33,14ZM17,96V4H63V23l2,2h18V96H17Zm42.59-22.41l2.83,2.83-11,11h-2.83l-11-11,2.83-2.83,7.59,7.59v-20.17h4v20.17l7.59-7.59Zm-21.17-27.17l2-2,.59-1.41v-4l-.59-1.41-2-2-1.41-.59h-8v18h4v-6h4l1.41-.59Zm-5.41-3.41v-4h3.17l.83,.83v2.34l-.83,.83h-3.17Zm38-8v4h-7v3h6v4h-6v7h-4v-18h11Zm-19,18l1.41-.59,2-2,.59-1.41v-10l-.59-1.41-2-2-1.41-.59h-8v18h8Zm-.83-14l.83,.83v8.34l-.83,.83h-3.17v-10h3.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigPdfExport);
export default __webpack_public_path__ + "static/1772534745/media/icon-big-pdf-export.ab04cc80095894ed39b996b0c1b2adbf.svg";
export { ForwardRef as ReactComponent };